import React from "react";
import styled from "styled-components";
import PageBuilder from "../../components/PageBuilder/PageBuilder";
import { useSanityContent } from "../../hooks/useSanityContent";
import { PAGE_QUERY } from "../../sanity/queries";

const ContactPageContainer = styled.div`
  min-height: 100vh;
  padding-top: 90px;
  background: #fff;
  @media (max-width: 768px) { padding-top: 100px; }
`;

const fallbackSections = [{ _type: "contactSection" }];

export default function ContactUs() {
  const { data } = useSanityContent(PAGE_QUERY("contact-us"), { sections: fallbackSections });
  return (
    <ContactPageContainer>
      <PageBuilder sections={data.sections} />
    </ContactPageContainer>
  );
}
